import NavLinkAdapter from '@fuse/core/NavLinkAdapter';
import { alpha, styled } from '@mui/material/styles';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import FuseNavBadge from '../../FuseNavBadge';
import FuseSvgIcon from '../../../FuseSvgIcon';
import { selectUser } from 'app/store/userSlice';
import { useSelector } from 'react-redux';

const Root = styled(ListItem)(({ theme, ...props }) => ({
  minHeight: 44,
  width: '100%',
  borderRadius: '6px',
  margin: '0 0 4px 0',
  paddingRight: 16,
  paddingLeft: props.itempadding > 80 ? 80 : props.itempadding,
  paddingTop: 10,
  paddingBottom: 10,
  color: alpha(theme.palette.text.primary, 0.7),
  cursor: 'pointer',
  textDecoration: 'none!important',
  '&:hover': {
    color: theme.palette.primary.light,
  },
  '&.active': {
    color: theme.palette.primary.main,
    backgroundColor:
      theme.palette.mode === 'light'
        ? 'rgba(0, 0, 0, .05)!important'
        : 'rgba(255, 255, 255, .1)!important',
    pointerEvents: 'none',
    transition: 'border-radius .15s cubic-bezier(0.4,0.0,0.2,1)',
    '& > .fuse-list-item-text-primary': {
      color: 'inherit',
    },
    '& > .fuse-list-item-icon': {
      color: 'inherit',
    },
  },
  '& >.fuse-list-item-icon': {
    marginRight: 16,
    color: 'inherit',
  },
  '& > .fuse-list-item-text': {},
}));

function FuseNavVerticalItem(props) {
  const { item, nestedLevel, onItemClick } = props;
  const itempadding = nestedLevel > 0 ? 38 + nestedLevel * 16 : 16;
  const user = useSelector(selectUser);

  const navItem =
    item.id === 'tickets-component' && user?.openTickets
      ? { ...item, badge: { title: user.openTickets } }
      : item;

  return useMemo(
    () => (
      <Root
        button
        component={NavLinkAdapter}
        to={navItem.url || ''}
        activeClassName={navItem.url ? 'active' : ''}
        className={clsx('fuse-list-item', navItem.active && 'active')}
        onClick={() => onItemClick && onItemClick(navItem)}
        end={navItem.end}
        itempadding={itempadding}
        role='button'
        sx={navItem.sx}
        disabled={navItem.disabled}
      >
        {navItem.icon && (
          <FuseSvgIcon
            className={clsx('fuse-list-item-icon shrink-0', navItem.iconClass)}
            color='action'
          >
            {navItem.icon}
          </FuseSvgIcon>
        )}
        <ListItemText
          className='fuse-list-item-text'
          primary={navItem.title}
          secondary={navItem.subtitle}
          classes={{
            primary: 'text-13 font-medium fuse-list-item-text-primary truncate',
            secondary: 'text-11 font-medium fuse-list-item-text-secondary leading-normal truncate',
          }}
        />
        {navItem.badge && <FuseNavBadge badge={navItem.badge} />}
      </Root>
    ),
    [navItem, itempadding, onItemClick],
  );
}

FuseNavVerticalItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    icon: PropTypes.string,
    url: PropTypes.string,
  }),
};

FuseNavVerticalItem.defaultProps = {};

const NavVerticalItem = FuseNavVerticalItem;

export default NavVerticalItem;
